import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import { isEqual as _isEqual } from 'lodash';

import { setFilters } from 'actions/SalesActivityDashboardActions';
import { parseQs, stringifyQs } from 'helpers/http';

import DocMeta from 'components/DocMeta';
import List from 'components/List';

import Loader from 'components/layout/Loader';

import ServiceRequestList from 'components/layout/connectme/ServiceRequestList';

class Connectme extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      initialised: true,
    };

    /* const query = parseQs(props.location.search)

    if (query && !_isEmpty(query) && !_isEqual(query, props.filters)) {
      props.setFilters(query)
      this.state.initialised = false // we need to wait until the filters state get updated
    } else if (props.filters && !_isEmpty(props.filters)) {
      // if there filters set in state, use them
      props.history.replace({
        pathname: props.location.pathname,
        search: stringifyQs(props.filters)
      })
    } else {
      props.history.replace({
        pathname: props.location.pathname,
        search: 'customFilter=all'
      })
      this.state.initialised = false // we need to wait until the filters state get updated
    }

    if (props.location && props.location.search) {
      console.log('constructor setFilters')
      props.setFilters(parseQs(props.location.search))
    } */
  }

  componentDidUpdate = prevProps => {
    const { location, filters, setFilters } = this.props;
    const { initialised } = this.state;

    if (!_isEqual(prevProps.location.search, location.search)) {
      // console.log('componentDidUpdate setFilters');
      setFilters(parseQs(location.search));
    }

    if (!initialised && !_isEqual(prevProps.filters, filters)) {
      // console.log('componentDidUpdate setState');
      this.setState({ initialised: true });
    }
  };

  onCustomFilterSelect = customFilter => {
    const query = parseQs(this.props.location.search);
    query.customFilter = customFilter;
    this.props.history.push({ pathname: this.props.location.pathname, search: stringifyQs(query) });
    this.props.setFilters(query);
  };

  render() {
    const { location, serviceRequestList } = this.props;
    const { initialised } = this.state;

    const urlData = { filters: { ...parseQs(location.search) } };

    return initialised ? (
      <DocMeta tags={[{ name: 'title', content: 'Connectme' }]}>
        <div class="p-t-20">
          <List
            noRender
            listName="serviceRequestList"
            url="/api/plugin/connectme/servicerequests.json"
            urlData={urlData}
            list={serviceRequestList}
          />

          <Grid fluid>
            {!serviceRequestList.pending ? (
              <div>
                <Row>
                  <Col xs={12}>
                    <h3>ConnectMe Service-Management</h3>
                    <div>
                      <span class="bold m-r-5">Filter:</span>
                      <span style={{ display: 'inline-block' }} class="m-r-5">
                        <Button
                          bsSize="sm"
                          style={{ backgroundColor: '#e0e0e0', color: '#000', borderColor: '#9e9e9e' }}
                          onClick={() => {
                            this.onCustomFilterSelect('all');
                          }}
                        >
                          Alle
                        </Button>
                      </span>
                      <span style={{ display: 'inline-block' }} class="m-r-5">
                        <Button
                          bsSize="sm"
                          bsStyle="danger"
                          onClick={() => {
                            this.onCustomFilterSelect('actionRequired');
                          }}
                        >
                          Manuelle Bearbeitung notwendig
                        </Button>
                      </span>
                      <span style={{ display: 'inline-block' }} class="m-r-5">
                        <Button
                          bsSize="sm"
                          style={{ backgroundColor: '#ffa000', color: '#FFF', borderColor: '#ffa000' }}
                          onClick={() => {
                            this.onCustomFilterSelect('resubmissionOverdue');
                          }}
                        >
                          Fällige Wiedervorlagen
                        </Button>
                      </span>
                    </div>
                  </Col>
                </Row>
                <ServiceRequestList serviceRequestList={serviceRequestList} />
              </div>
            ) : (
              <div class="p-t-50 p-b-50">
                <Loader />
              </div>
            )}
          </Grid>
        </div>
      </DocMeta>
    ) : null;
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    serviceRequestList: state.list.serviceRequestList,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setFilters: filters => {
      dispatch(setFilters(filters));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Connectme)
  )
);
